import { DIALOG_NAME, useDialogSearchParam } from "../helpers/useDialogSearchParam";
import LoginModal from "./login/LoginModal";

const ContentGate = () => {
  const [isParamSet, removeParam] = useDialogSearchParam(DIALOG_NAME.login);

  return <LoginModal isOpen={isParamSet} onClose={removeParam} />;
};

export default ContentGate;
